import { MouseEvent, useEffect, useState } from 'react';
import { Steps, Step } from '@gaiads/telia-react-component-library';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IMPORT_USERS_FLOW_CONSTANTS } from '../../../../utils/constants';

export const importUsersBaseUrl = '/users/import';

export default function ImportUsersStepper() {
  const [stepIndex, setStepIndex] = useState(0);
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation('editOrganization');

  const activateRightStep = (path: string) => {
    switch (path) {
      case `${importUsersBaseUrl}/${IMPORT_USERS_FLOW_CONSTANTS.uploadTemplate}`:
        setStepIndex(0);
        break;
      case `${importUsersBaseUrl}/${IMPORT_USERS_FLOW_CONSTANTS.reviewAndSave}`:
        setStepIndex(1);
        break;
      case `${importUsersBaseUrl}/${IMPORT_USERS_FLOW_CONSTANTS.summary}`:
        setStepIndex(2);
        break;
      default:
        setStepIndex(0);
        break;
    }
  };

  useEffect(() => {
    activateRightStep(location.pathname);
  }, [location.pathname]);

  const handleSelect = (_e: MouseEvent<HTMLDivElement>, index: number) => {
    switch (index) {
      case 0:
        history.push(`${importUsersBaseUrl}/${IMPORT_USERS_FLOW_CONSTANTS.uploadTemplate}`);
        break;
      case 1:
        history.push(`${importUsersBaseUrl}/${IMPORT_USERS_FLOW_CONSTANTS.reviewAndSave}`);
        break;
      case 2:
        history.push(`${importUsersBaseUrl}/${IMPORT_USERS_FLOW_CONSTANTS.summary}`);
        break;
    }
  };

  const handleSelectable = (index: number, selectedStepIndex: number) => {
    const lastStep = 2;
    return index === 0 && selectedStepIndex !== lastStep;
  };

  return (
    <Steps selectedStepIndex={stepIndex} onSelect={handleSelect} isStepSelectable={handleSelectable}>
      <Step label="1" description={t('usersAdmin.importUsers.uploadTemplateStep')} />
      <Step label="2" description={t('usersAdmin.importUsers.reviewAndSaveStep')} />
      <Step label="3" description={t('usersAdmin.importUsers.summary')} />
    </Steps>
  );
}
